import type { MovementId } from '../config/movements';
import type { RfidDocumentRow } from '../services/rfid.service';

export type WizardVariant = 'kit' | 'flat';

/** Transfer-out header fields (legacy Customer step — not full LEAP transport UDF). */
export type TransferDetails = {
  vehicleNo: string;
  transporterName: string;
  invoiceNo: string;
  lrNo: string;
  location: string;
};

export const emptyTransferDetails = (): TransferDetails => ({
  vehicleNo: '',
  transporterName: '',
  invoiceNo: '',
  lrNo: '',
  location: '',
});

export type TransportDetails = {
  TRANSPORTER_CODE: string;
  TRANSPORTER_NAME: string;
  VEHICLE_NO: string;
  VEHICLE_TYPE: string;
  DRIVER_NAME: string;
  DRIVER_MOB_NO: string;
  TRANPORTATION_BY: string;
  INSPECTEDBY: string;
  LR_NO: string;
  DIRECT_DISPLATCH: string;
  distance: string;
  reason: string;
  containerSeal: string;
  eway: string;
  pod: string;
  TRANSPORT_MODE: string;
  freight: string;
};

export type WizardLine = {
  id: string;
  itemNo: string;
  materialCode: string;
  materialDesc: string;
  quantity: number;
  scannable: boolean;
  scanQty: number;
  /** null = auto (required − scan tags); number = operator-entered non-RFID qty */
  nonScanQty: number | null;
  /** Short / shortage qty (LEAPIN dehire received) — posted as Short_Qty */
  shortQty: number;
  fromBay: string;
  fromBin: string;
  toBay: string;
  toBin: string;
  sender: string;
  senderName: string;
  materialGroupCode?: string;
  materialGroupName?: string;
  rfidCodes: string[];
  isKitHeader?: boolean;
  kitQty?: number;
};

export type KitGroup = {
  kitMaterial: string;
  kitDesc: string;
  kitQty: number;
  sender: string;
  senderName: string;
  lines: WizardLine[];
};

export type TransferContext = {
  fromBpCode: string;
  fromCustomerName: string;
  toBpCode: string;
  toCustomerName: string;
  lineOfBusiness?: string;
};

export type WizardSession = {
  movementId: MovementId;
  document: RfidDocumentRow;
  variant: WizardVariant;
  effectiveDate: Date;
  transport: TransportDetails;
  lines: WizardLine[];
  kitGroups: KitGroup[];
  activeKitIndex: number;
  remarks: string;
  transfer?: TransferContext;
};
